// SystemDevice Saga
import { call, put, takeEvery, all, fork } from "redux-saga/effects";

import {
  GET_SYSTEM_DEVICE_LIST,
  GET_EPOSSYSTEM_DATA,
  CREATE_SYSTEM_DEVICE,
  UPDATE_SYSTEM_DEVICE,
  DELETE_SYSTEM_DEVICE,
} from "./actionType";

import {
  getSystemDeviceListSuccess,
  getSystemDeviceListFailure,
  getEposSystemDataSuccess,
  getEposSystemDataFailure,
  createSystemDeviceSuccess,
  createSystemDeviceFailure,
  updateSystemDeviceSuccess,
  updateSystemDeviceFailure,
  deleteSystemDeviceSuccess,
  deleteSystemDeviceFailure,
} from "./action";

import {
  getPosSystemListAPI,
  getPosSystemDataAPI,
  createPosSystemAPI,
  updatePosSystemAPI,
  deletePosSystemAPI,
} from "../../helpers/fakebackend_helper";

function* getSystemDeviceListWorker() {
  try {
	const response = yield call(getPosSystemListAPI);
	yield put(getSystemDeviceListSuccess(response));
  } catch (error) {
	yield put(getSystemDeviceListFailure(error));
  }
}

function* getSystemDeviceListWatcher() {
  yield takeEvery(GET_SYSTEM_DEVICE_LIST, getSystemDeviceListWorker);
}

function* getEposSystemDataWorker(action) {
  try {
	const response = yield call(getPosSystemDataAPI, action.payload);
	yield put(getEposSystemDataSuccess(response));
  } catch (error) {
	yield put(getEposSystemDataFailure(error));
  }
}

function* getEposSystemDataWatcher() {
  yield takeEvery(GET_EPOSSYSTEM_DATA, getEposSystemDataWorker);
}

function* createSystemDeviceWorker(action) {
  try {
	const response = yield call(createPosSystemAPI, action.payload);
	yield put(createSystemDeviceSuccess(response));
  } catch (error) {
	yield put(createSystemDeviceFailure(error));
  }
}

function* createSystemDeviceWatcher() {
  yield takeEvery(CREATE_SYSTEM_DEVICE, createSystemDeviceWorker);
}

function* updateSystemDeviceWorker(action) {
  try {
	const response = yield call(updatePosSystemAPI, action.payload);
	yield put(updateSystemDeviceSuccess(response));
  } catch (error) {
	yield put(updateSystemDeviceFailure(error));
  }
}

function* updateSystemDeviceWatcher() {
  yield takeEvery(UPDATE_SYSTEM_DEVICE, updateSystemDeviceWorker);
}

function* deleteSystemDeviceWorker(action) {
  try {
	const response = yield call(deletePosSystemAPI, action.payload);
	yield put(deleteSystemDeviceSuccess(response));
  } catch (error) {
	yield put(deleteSystemDeviceFailure(error));
  }
}

function* deleteSystemDeviceWatcher() {
  yield takeEvery(DELETE_SYSTEM_DEVICE, deleteSystemDeviceWorker);
}

function* SystemDeviceSaga() {
  yield all([
	fork(getSystemDeviceListWatcher),
	fork(getEposSystemDataWatcher),
	fork(createSystemDeviceWatcher),
	fork(updateSystemDeviceWatcher),
	fork(deleteSystemDeviceWatcher),
  ]);
}

export default SystemDeviceSaga;


